import { render, staticRenderFns } from "./m-editAnswerEssayChild.vue?vue&type=template&id=184a2559&"
import script from "./m-editAnswerEssayChild.vue?vue&type=script&lang=js&"
export * from "./m-editAnswerEssayChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports